// extracted by mini-css-extract-plugin
export default {"slider":"_slider_EJdXbE","hints":"_hints_52BVKL"};